import Util from '../Util';
import _ from 'lodash';
import moment from 'moment-timezone';

import {
  AUTH_TYPE_RT,
  AUTH_TYPE_V5,
  AUTH_TYPE_HE_COLO_SVR,
  AUTH_TYPE_HE_COLO_DB_SVR,
  AUTH_TYPE_HE_COLO_TEST_SVR,
  AUTH_TYPE_CA_OFFICE_SVR,
  AUTH_TYPE_AWS_OREGON,
  AUTH_TYPE_AWS_OHIO,
} from '../Constants';

class HostInfo {
  constructor(obj = {}) {
    obj = obj || {}; // check for null and empty string, the default value only check for undefined

    this.id = obj.id;
    this.ip = obj.ip;
    this.macAddress = obj.macAddress;
    this.iface = obj.iface;
    this.hostname = obj.hostname;
    this.fingerprint = obj.fingerprint;
    this.optConnectSerialNumber = obj.optConnectSerialNumber;
    this.castlesSerialNumber = obj.castlesSerialNumber;

    this.sosdbTimezoneOffset = obj.sosdbTimezoneOffset;
    this.sosdbTimezoneLong = obj.sosdbTimezoneLong;

    this.kioskId = obj.kioskId;
    this.kioskName = obj.kioskName;
    this.kioskType = obj.kioskType;
    this.locationName = obj.locationName;
    this.orgName = obj.orgName;

    this.basicInfo = Util.jsonParse(obj.basicInfo);
    this.kioskInfo = Util.jsonParse(obj.kioskInfo);
    this.serverInfo = Util.jsonParse(obj.serverInfo);
    this.sosdbKiosk = obj.sosdbKiosk;

    // workaround issue where this.ip is empty for some reason
    if (
      !Util.isValidIpAddress(this.ip) &&
      this.basicInfo &&
      Util.isValidIpAddress(this.basicInfo.ipaddr)
    ) {
      this.ip = this.basicInfo.ipaddr;
    }
    if (
      !Util.isValidIpAddress(this.ip) &&
      this.sosdbKiosk &&
      Util.isValidIpAddress(this.sosdbKiosk.ipaddress)
    ) {
      this.ip = this.kioskInfo.ipaddress;
    }

    this.linuxdashVer = obj.linuxdashVer;
    this.authType = obj.authType;
    this.fetchStatus = obj.fetchStatus;
    this.lastFetched = obj.lastFetched;
    this.lastUpdated = obj.lastUpdated;
    this.dateCreated = obj.dateCreated;

    //
    // derived from basicInfo
    //
    this.os = obj.os;
    this.uptime = obj.uptime;
    this.upsince = obj.upsince;
    this.installedAt = obj.installedAt;
    this.timezone = obj.timezone;
    this.timezoneOffset = obj.timezoneOffset;
    this.timezoneLong = obj.timezoneLong;

    this.cpuNumOfCores = obj.cpuNumOfCores;
    this.cpuModelInfo = obj.cpuModelInfo;
    this.cpu1MinLoadAvgPercent = obj.cpu1MinLoadAvgPercent;
    this.cpu5MinLoadAvgPercent = obj.cpu5MinLoadAvgPercent;
    this.cpu15MinLoadAvgPercent = obj.cpu15MinLoadAvgPercent;
    this.totalProcesses = obj.totalProcesses;

    this.memUsedPercent = obj.memUsedPercent;
    this.memUsedMB = obj.memUsedMB;
    this.memTotalMB = obj.memTotalMB;
    this.diskUsedPercent = obj.diskUsedPercent;
    this.diskUsed = obj.diskUsed;
    this.diskTotal = obj.diskTotal;
    this.externalIP = obj.externalIP;
    this.systemInfo = obj.systemInfo;

    //
    // derived from sosdbKiosk
    //
    this.hasSosdbKiosk = obj.hasSosdbKiosk;
    this.sosdbOrgName = obj.sosdbOrgName;
    this.sosdbLocName = obj.sosdbLocName;
    this.sosdbKioskName = obj.sosdbKioskName;
    this.sosdbGoLive = obj.sosdbGoLive;
    this.sosdbTag = obj.sosdbTag;
    this.sosdbDeploymentSet = obj.sosdbDeploymentSet;
    this.sosdbDeploymentTime = obj.sosdbDeploymentTime;
    this.sosdbKioskStatus = obj.sosdbKioskStatus;
    this.sosdbMonitor = obj.sosdbMonitor;
    this.sosdbLastTransId = obj.sosdbLastTransId;
    this.sosdbLastFullSync = obj.sosdbLastFullSync;
    this.sosdbLastUpdPrices = obj.sosdbLastUpdPrices;
    this.sosdbLastTransDate = obj.sosdbLastTransDate;
    this.sosdbLastPoll = obj.sosdbLastPoll;
    this.sosdbTimezoneLong = obj.sosdbTimezoneLong;
    this.sosdbTimezoneOffset = obj.sosdbTimezoneOffset;
    this.sosdbTimezone = obj.sosdbTimezone;
    this.sosdbPatchTime = obj.sosdbPatchTime;
    this.sosdbPatchDate = obj.sosdbPatchDate;
    this.patchDateTime = this.sosdbPatchDate + ' ' + this.sosdbPatchTime;

    //
    // derived from kioskInfo
    //
    this.hasKioskInfo = obj.hasKioskInfo;
    this.kioskISOVersion = obj.kioskISOVersion;
    this.lastSuccessfulPatchedDate = obj.lastSuccessfulPatchedDate;

    this.touchscreen = obj.touchscreen;
    this.touchscreenType = obj.touchscreenType;
    this.kioskTouchDriver = obj.kioskTouchDriver;
    this.currentTouchAxis = obj.currentTouchAxis;
    this.calibratedTouchAxis = obj.calibratedTouchAxis;

    this.kskapiVersion = obj.kskapiVersion || '';
    this.cafeapiVersion = obj.cafeapiVersion || '';
    this.payapiVersion = obj.payapiVersion || '';
    this.printapiVersion = obj.printapiVersion || '';
    this.capuiVersion = obj.capuiVersion || '';
    // this.mmVersion = obj.mmVersion || '';
    this.heatwaveVersion = obj.heatwaveVersion || '';
    this.cortexAgentVersion = obj.cortexAgentVersion || '';
    this.kioskprobeVersion = obj.kioskprobeVersion || '';
    this.ciscoampVersion = obj.ciscoampVersion || '';

    this.kskapiRunning = obj.kskapiRunning;
    this.cafeapiRunning = obj.cafeapiRunning;
    this.payapiRunning = obj.payapiRunning;
    this.printapiRunning = obj.printapiRunning;
    this.capuiRunning = obj.capuiRunning;
    // this.mmRunning = obj.mmRunning;
    this.heatwaveRunning = obj.heatwaveRunning;
    this.cortexAgentRunning = obj.cortexAgentRunning;
    this.kioskprobeRunning = obj.kioskprobeRunning;
    this.ciscoampRunning = obj.ciscoampRunning;

    this.teamviewerClientID = obj.teamviewerClientID;
    this.capuiDeviceName = obj.capuiDeviceName;
    this.aprivaPortCheck = obj.aprivaPortCheck;

    this.usbMSR = obj.usbMSR;
    this.otiFirmware = obj.otiFirmware;
    this.otiConfig = obj.otiConfig;
    this.usbWebCam = obj.usbWebCam;
    this.usbFingerprintReader = obj.usbFingerprintReader;
    this.usbBarcodeScanner = obj.usbBarcodeScanner;
    this.usbBillAcceptor = obj.usbBillAcceptor;
    this.usbScale = obj.usbScale;
    this.usbPrinter = obj.usbPrinter;
    this.usbCoinDispenser = obj.usbCoinDispenser;
    this.usbCashlessReader = obj.usbCashlessReader;
    this.usbTemperatureSensor = obj.usbTemperatureSensor;
    this.usbCustomerLineDisplay = obj.usbCustomerLineDisplay;

    this.cupsPendingPrintJobs = obj.cupsPendingPrintJobs;
    this.cupsHasDefaultPrinter = obj.cupsHasDefaultPrinter;

    this.kskapiMode = obj.kskapiMode;
    this.payapiCCMode = obj.payapiCCMode;
    this.payapiProcessorsStatus = obj.payapiProcessorsStatus;

    this.sfecfgServices = obj.sfecfgServices;
    this.sfecfgServicesText = obj.sfecfgServicesText;

    this.kskcfgServerUrl = obj.kskcfgServerUrl;
    this.kskcfgUsingProdServerUrl = obj.kskcfgUsingProdServerUrl;
    this.kskcfgUsingAwsProdServerUrl = obj.kskcfgUsingAwsProdServerUrl;

    this.kskdbTransqueCount = obj.kskdbTransqueCount;
    this.kskdbCCLocalCount = obj.kskdbCCLocalCount;
    this.kskdbCCQuarantineCount = obj.kskdbCCQuarantineCount;
    this.kskdbSahCount = obj.kskdbSahCount;
    this.kskdbSapCount = obj.kskdbSapCount;

    // SOS-15639
    this.kskdbCCLocalDate = obj.kskdbCCLocalDate;
    this.kskdbCCQuarantineDate = obj.kskdbCCQuarantineDate;
    this.kskdbCCLocalXAgo = '';
    this.kskdbCCQuarantineXAgo = '';
    if (this.kskdbCCLocalDate) {
      let ccLocalM = moment.tz(this.kskdbCCLocalDate, 'YYYY-MM-DD HH:mm:ss', this.timezoneLong);
      this.kskdbCCLocalLocalDate = ccLocalM.toString();
      let duration = moment.duration(new moment().diff(ccLocalM));
      if (duration.days() == 0) {
        this.kskdbCCLocalXAgo = duration.hours() + ' hours ago';
      } else if (duration.years() == 0){
        this.kskdbCCLocalXAgo = duration.months() + ' month(s) ' + duration.days() + ' days ago';
      } else {
        let years = duration.years();
        let yearsToMonths = years * 12;
        let totalMonths = yearsToMonths + duration.months();
        this.kskdbCCLocalXAgo = totalMonths + ' month(s) ' + duration.days() + ' days ago';
      }
    }
    if (this.kskdbCCQuarantineDate) {
      let ccQuaM = moment.tz(this.kskdbCCQuarantineDate, 'YYYY-MM-DD HH:mm:ss', this.timezoneLong);
      this.kskdbCCQuarantineLocalDate = ccQuaM.toString();
      let duration = moment.duration(new moment().diff(ccQuaM));
      if (duration.days() == 0) {
        this.kskdbCCQuarantineXAgo = duration.hours() + ' hours ago';
      } else {
        this.kskdbCCQuarantineXAgo = duration.days() + ' days ago';
      }
    }

    this.kskdbx = obj.kskdbx;
    this.salesdbx = obj.salesdbx;
    this.ccdbx = obj.ccdbx;

    this._parseBasicInfo();
    this._parseKioskInfo();
    this._parseServerInfo();
    this._parseExtra();
  }

  _parseBasicInfo() {
    this.basicInfo.java = this.basicInfo.java || {};
    this.java = this.java || this.basicInfo.java.version;
    if (this.java) {
      this.java = this.java.replace(/java version /, '');
    }

    this.basicInfo.jdk7 = this.basicInfo.jdk7 || {};
    this.jdk7 = this.jdk7 || this.basicInfo.jdk7.version;

    this.basicInfo.jdk8 = this.basicInfo.jdk8 || {};
    this.jdk8 = this.jdk8 || this.basicInfo.jdk8.version;

    this.basicInfo.mariadb5 = this.basicInfo.mariadb5 || {};
    this.basicInfo.mariadb10 = this.basicInfo.mariadb10 || {};
    this.mariadb = this.mariadb || this.basicInfo.mariadb5.version;
    if (!this.mariadb) {
      this.mariadb = this.basicInfo.mariadb10.version;
    }
  }

  _parseKioskInfo() {
    this.kioskInfo.cups = this.kioskInfo.cups || {};
    this.kioskInfo.cups.printers = [];
    if (this.kioskInfo.cups.printerList) {
      let parts = this.kioskInfo.cups.printerList.trim().split(/\s+/);
      let printers = [];
      for (let i = 0; i < parts.length; i += 2) {
        printers.push(parts[i] + ' ' + parts[i + 1]);
      }
      this.kioskInfo.cups.printers = printers;
    }
  }

  _parseServerInfo() {
    this.serverInfo.dockerContainers = this.serverInfo.dockerContainers || []; // container name array
    this.serverInfo.containers = this.serverInfo.containers || []; // container info object array
    this.hasContainers = this.serverInfo.dockerContainers.length > 0;

    this.serverInfo.app = this.serverInfo.app || {};
    for (let name in this.serverInfo.app) {
      this.serverInfo.app[name] = parseApp(this.serverInfo.app[name], name);

      // parse apps inside container
      for (let cont of this.serverInfo.containers) {
        cont = cont || {};
        cont.serverInfo = cont.serverInfo || {};
        cont.serverInfo.app = cont.serverInfo.app || {};
        for (let name in cont.serverInfo.app) {
          cont.serverInfo.app[name] = parseApp(cont.serverInfo.app[name], name);
        }
      }
    }
    if (Object.keys(this.serverInfo.app).length > 0) {
      this.hasSvrApp = true;
    }
  }

  _parseExtra() {
    if (/MQ/.test(this.kioskType)) {
      this.isMQKskType = true;
    } else if (/KIOSK/.test(this.kioskType)) {
      this.isVPNKskType = true;
    }

    this.kskcfgUsingHEColoProdServerUrl =
      this.kskcfgUsingProdServerUrl && !this.kskcfgUsingAwsProdServerUrl;
    this.inLocalStatus =
      /local/.test(this.kskapiMode) ||
      /local/.test(this.payapiProcessorsStatus) ||
      this.kskdbTransqueCount > 0 ||
      this.kskdbCCLocalCount > 0 ||
      this.kskdbCCQuarantineCount > 0;
    this.memTotal = Math.round(this.memTotalMB / 1000).toFixed(0) + 'G';

    this.sosdbLastFullSyncXAgo = '-';
    if (this.sosdbLastFullSync) {
      this.sosdbLastFullSyncXAgo = Util.xUnitsOfTimeAgo(this.sosdbLastFullSync);
      this.sosdbLastFullSync = Util.localDateTimeString(this.sosdbLastFullSync);
    }

    this.sosdbLastUpdPricesXAgo = '-';
    if (this.sosdbLastUpdPrices) {
      this.sosdbLastUpdPricesXAgo = Util.xUnitsOfTimeAgo(this.sosdbLastUpdPrices);
      this.sosdbLastUpdPrices = Util.localDateTimeString(this.sosdbLastUpdPrices);
    }

    this.sosdbLastTranDateXAgo = '-';
    if (this.sosdbLastTransDate) {
      this.sosdbLastTranDateXAgo = Util.xUnitsOfTimeAgo(this.sosdbLastTransDate);
      this.sosdbLastTranDate = Util.localDateTimeString(this.sosdbLastTransDate);
    }

    // to use capui column to display mm version
    //if (!this.capuiRunning && this.mmRunning) {
    //  this.capuiVersion = 'mm ' + this.mmVersion;
    //  this.capuiRunning = true;
    //}

    this._parseUptime();
    this._parseConfigCompare();
    this._parseHostType();
    this._parseFetchStatus();
  }

  _parseHostType() {
    this.isV5Kiosk = this.authType === AUTH_TYPE_V5;
    this.isRTKiosk = this.authType === AUTH_TYPE_RT;
    this.isAwsOregonSvr = this.authType === AUTH_TYPE_AWS_OREGON;
    this.isAwsOhioSvr = this.authType === AUTH_TYPE_AWS_OHIO;
    this.isHEColoSvr = this.authType === AUTH_TYPE_HE_COLO_SVR;
    this.isHEColoDBSvr = this.authType === AUTH_TYPE_HE_COLO_DB_SVR;
    this.isHEColoTestSvr = this.authType === AUTH_TYPE_HE_COLO_TEST_SVR;
    this.isCaOfficeSvr = this.authType === AUTH_TYPE_CA_OFFICE_SVR;

    this.hostType = 'Unknown';
    if (this.isV5Kiosk) {
      this.hostType = 'V5';
    } else if (this.isRTKiosk) {
      this.hostType = 'RT';
    } else if (this.isAwsOregonSvr) {
      this.hostType = 'AWS Oregon Server';
    } else if (this.isAwsOhioSvr) {
      this.hostType = 'AWS Ohio Server';
    } else if (this.isHEColoSvr) {
      this.hostType = 'HE Colo Server';
    } else if (this.isHEColoDBSvr) {
      this.hostType = 'HE Colo DB Server';
    } else if (this.isHEColoTestSvr) {
      this.hostType = 'HE Colo Test Server';
    } else if (this.isCaOfficeSvr) {
      this.hostType = 'CA Office Server';
    }

    if (this.isV5Kiosk || this.isRTKiosk) {
      this.kioskHW = this.hostType;
    }
  }

  _parseUptime() {
    if (this.uptime) {
      this.uptime = this.uptime.replace(/^\s+/, '').replace(/\s+$/, '');
      if (/^\d+ days/.test(this.uptime)) {
        this.uptime = this.uptime.replace(/ \d+ minutes/, '');
        this.uptime = this.uptime.replace(/ and \d+ seconds/, '');
      } else if (/^\d+ hours/.test(this.uptime)) {
        this.uptime = this.uptime.replace(/ \d+ minutes/, '');
        this.uptime = this.uptime.replace(/ and \d+ seconds/, '');
      } else if (/^\d+ minutes/.test(this.uptime)) {
        this.uptime = this.uptime.replace(/ and \d+ seconds/, '');
      }
    }
  }

  _parseConfigCompare() {
    this.kskSameTimezone = '';
    if (
      this.sosdbTimezoneOffset &&
      this.timezoneOffset &&
      this.sosdbTimezoneLong &&
      this.timezoneLong
    ) {
      if (
        this.sosdbTimezoneOffset === this.timezoneOffset ||
        this.sosdbTimezoneLong === this.timezoneLong
      ) {
        this.kskSameTimezone = 'Yes';
      } else {
        this.kskSameTimezone = 'No';
      }
    }
    if (!this.sosdbTimezoneOffset) {
      this.kskSameTimezone = '-';
    }

    this.kskSameName = this.kioskName === this.capuiDeviceName ? 'Yes' : 'No';
    this.kskSameLocName = this.locationName === this.sosdbLocName ? 'Yes' : 'No';
    this.kskSameOrgName = this.orgName === this.sosdbOrgName ? 'Yes' : 'No';
    this.kskSameTouchAxis = this.currentTouchAxis === this.calibratedTouchAxis ? 'Yes' : 'No';
    if (!this.currentTouchAxis) {
      this.kskSameTouchAxis = '-';
    }
  }

  _parseFetchStatus() {
    this.lastFetchedDateTime = Util.localDateTimeString(this.lastFetched);
    this.lastFetchedXAgo = Util.xUnitsOfTimeAgo(this.lastFetched);
    // set inactive if no dashbeat within last 30 days
    this.isActive = !Util.moreThanXHoursAgo(this.lastFetched, 24 * 30);
    // more than 30 days
    this.isOldFetchStatus = Util.moreThanXHoursAgo(this.lastFetched, 24 * 30);
    this.isBadFetchStatus =
      /Failed/.test(this.fetchStatus) ||
      /HTTP/.test(this.fetchStatus) ||
      Util.moreThanXMinutesAgo(this.lastFetched, 60);
  }

  calculateKvsNames(kvsList = []) {
    let kvsNameSet = this._getNameSet(kvsList);
    let kvsNames = ''; // actual deployment set matched
    let array = [];
    for (let name of kvsNameSet) {
      array.push(name);
    }
    array.sort(function (a, b) {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });

    for (let name of array) {
      kvsNames += name + ', ';
    }
    kvsNames = kvsNames.replace(/, $/, '');
    if (!kvsNames) {
      kvsNames = 'unknown';
    }
    this.kvsNames = kvsNames;
  }

  _getNameSet(kvsList = []) {
    let kvsNameSet = new Set();
    for (let kvs of kvsList) {
      let samePrintapi = sameVersion(this.printapiVersion, kvs.printapi);
      let samePayapi = sameVersion(this.payapiVersion, kvs.payapi);
      let sameKskapi = sameVersion(this.kskapiVersion, kvs.kskapi);
      let sameCapui = sameVersion(this.capuiVersion, kvs.capui);
      // consider same, if there is no optional services like linuxdash, heatwave, and smtkms
      let sameLinuxdash = _.isEmpty(kvs.linuxdash) || sameVersion(this.linuxdashVer, kvs.linuxdash);
      let sameHeatwave = _.isEmpty(kvs.heatwave) || sameVersion(this.heatwaveVersion, kvs.heatwave);
      let sameKioskprobe = _.isEmpty(kvs.kioskprobe) || sameVersion(this.kioskprobeVersion, kvs.kioskprobe);
      let sameCafeapi = _.isEmpty(kvs.cafeapi) || sameVersion(this.cafeapiVersion, kvs.cafeapi);
      let sameCortexAgent = sameVersion(this.cortexAgentVersion, kvs.cortexagent);
      if (
        samePrintapi &&
        samePayapi &&
        sameKskapi &&
        sameCapui &&
        sameLinuxdash &&
        sameHeatwave &&
        sameKioskprobe &&
        sameCafeapi &&
        sameCortexAgent
      ) {
        if (!kvsNameSet.has(kvs.name)) {
          kvsNameSet.add(kvs.name);
        }
      }
    }
    return kvsNameSet;
  }
}

function sameVersion(v1 = '', v2 = '') {
  // strip 'v' from the front and compare as old service like smtkms doesn't have 'v' in front of version
  return v1.replace(/^v/, '') === v2.replace(/^v/, '');
}

function parseApp(app = {}, appName) {
  app.version = app.version || '';
  app.running = /^Running/.test(app.status);
  app.installed = !!app.version || (app.status && !/^Not Installed/.test(app.status));

  let verParts = app.version.split('-');
  app.branch = verParts.length > 1 ? app.version.substring(app.version.indexOf('-') + 1) : '';
  app.name = appName;
  app.deployName = appName + (app.branch ? ':' + app.branch : '');
  if (verParts[0] && verParts[0] !== 'unknown')
    app.versionOnly = 'v' + verParts[0].replace(/^v/, '');
  return app;
}

export default HostInfo;



// WEBPACK FOOTER //
// ./src/model/HostInfo.js